import { appActions } from '@app';
import { useAction } from '@hooks';

export function usePeriscopeReset(): () => void {
	return useAction(appActions.resetPeriscope);
}
